import { useContext } from "react";
import { PatientProfile } from "src/api/types";
import { PatientContext } from "./PatientProvider";

export function usePatient<T>(select: (patient: PatientProfile) => T) {
  const patient = useContext(PatientContext);

  if (patient == null) {
    throw new Error(`usePatient is used outside of PatientProvider`);
  }

  return select(patient);
}
